<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              ref="master"
              :parentData="parentData"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Objetivo')">
              <a-input
                v-decorator="['objective', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        master: {
          endpoint: 'strategic_objectives',
          tableSetup: {
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'Objetivo', dataIndex: 'objective', sorter: true}
            ]
          }
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        }
      }
    },
    props: ['id_training'],
    computed: {
      parentData () {
        return {
          id_training: this.id_training
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/StrategicObjective.vue